import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@node-space/storybook-components'
import StatusPill from '@node-space/storybook-components/dist/StatusPill'
import { IdVerificationLink } from 'components/IdVerification/IdVerificationLink'
import { IndividualVerificationStatus, PersonDetails } from 'types/identityVerification'
import { getIndividualStatus, getIndividualStatusLabel } from 'utils/utils'

interface IndividualVerificationDetailProps {
  individual: PersonDetails
}

export const IndividualVerificationDetail = ({ individual }: IndividualVerificationDetailProps) => {
  const { t } = useTranslation()

  const getLatestIdentification = individual?.identifications
    ?.filter(identification => identification?.status === IndividualVerificationStatus.PENDING)
    ?.reduce((latest, current) => {
      return new Date(latest.dateCreated) > new Date(current.dateCreated) ? latest : current
    })

  const updatedIndividual = {
    ...individual,
    identifications: getLatestIdentification,
  }

  const isIndividualVerificationPending = !!updatedIndividual?.identifications
  const individualVerificationStatus = updatedIndividual?.identifications?.status

  return (
    isIndividualVerificationPending && (
      <Box flex direction="col" gapY={8} paddingY={8}>
        <Box flex direction="row" justifyContent="between" alignItems="center" gapY={8}>
          <Text color="inherit">
            {updatedIndividual?.firstName} {updatedIndividual?.lastName}
          </Text>
          <Box flex justifyContent="center">
            <StatusPill
              displayAsDot
              state={getIndividualStatus(individualVerificationStatus)}
              label={t(
                `verification.individual.status.${getIndividualStatusLabel(individualVerificationStatus)?.toLowerCase()}`
              )}
              fitContent
            />
          </Box>
        </Box>
        <IdVerificationLink
          key={updatedIndividual?.reference}
          url={updatedIndividual?.identifications?.url}
        />
      </Box>
    )
  )
}
